import { render, staticRenderFns } from "./FileDeleteDialog.vue?vue&type=template&id=2db269c3&scoped=true&lang=html"
import script from "./FileDeleteDialog.vue?vue&type=script&lang=js"
export * from "./FileDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db269c3",
  null
  
)

export default component.exports